export var getLeadFactorySeller = function getLeadFactorySeller(sellers) {
  return sellers.find(function (seller) {
    return seller.isLeadFactory;
  });
};